import React, { useEffect } from 'react';
import Layout from "../components/layout";
import ClinicDetailSection from "../components/ClinicDetailSection";
import SingularMapSection from "../components/SingularMapSection";
import ContentContainer from "../components/widgets/ContentContainer";
import HeaderSecton from "../components/widgets/Header";
import { useStaticQuery, graphql } from "gatsby";

export default function ClinicDetailView({ clinic }) {
  const communityHeaderData = useStaticQuery(graphql`
    query StaticImageQueryCommunityResource {
      datoCmsSetting {
        communityResourcesHeaderText
        communityResourcesText
        communityResourcesBackgroundImage {
          fluid {
            base64
            aspectRatio
            width
            height
            src
            srcSet
            sizes
          }
        }
      }
    }
  `);

  const {
    communityResourcesHeaderText,
    communityResourcesText,
    communityResourcesBackgroundImage
  } = communityHeaderData.datoCmsSetting;

  // Intercept PDF button clicks in community resources section and trigger print
  React.useEffect(() => {
    if (!clinic || typeof window === 'undefined') return;

    const handlePDFButtonClick = (e) => {
      const target = e.target.closest('a');
      if (!target) return;

      const href = target.getAttribute('href');
      // Check if this is a PDF link in the community resources section
      if (href && href.endsWith('.pdf')) {
        e.preventDefault();
        e.stopPropagation();

        // Construct the print page URL with autoprint parameter
        const printPageUrl = `/suboxone-clinics/${clinic.slug}/community-resources?autoprint=true`;
        console.log('Loading print page:', printPageUrl);

        // Create an iframe positioned off-screen
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '-9999px';
        iframe.style.left = '-9999px';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.style.border = 'none';
        iframe.style.opacity = '0';

        // Handle iframe load
        iframe.onload = () => {
          console.log('Iframe loaded, URL:', iframe.contentWindow.location.href);
          // The print page will auto-trigger print via the autoprint parameter

          setTimeout(() => {
            if (iframe.parentNode) {
              document.body.removeChild(iframe);
            }
          }, 3000);
        };

        iframe.src = printPageUrl;
        document.body.appendChild(iframe);
      }
    };

    document.addEventListener('click', handlePDFButtonClick, true);

    return () => {
      document.removeEventListener('click', handlePDFButtonClick, true);
    };
  }, [clinic]);

  if (!clinic) {
    return null;
  }

  return (
    <Layout page={clinic}>
      <SingularMapSection
        data={[clinic]}
        state={clinic.state}
      />
      <ClinicDetailSection
        clinic={clinic}
        withButton={!(clinic.contentContainer)}
      />
      {clinic.contentContainer && (
        <React.Fragment>
          {communityResourcesBackgroundImage && (
            <HeaderSecton
              widget={{
                title: communityResourcesHeaderText,
                text: communityResourcesText,
                headerSize: "Small",
                backgroundImage: {
                  fluid: communityResourcesBackgroundImage.fluid
                }
              }}
            />
          )}
          <ContentContainer
            widget={clinic.contentContainer}
            withButton={true}
          />
        </React.Fragment>
      )}
    </Layout>
  );
}
